import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'lib-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationDialogComponent {
  constructor(
    private readonly matDialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { confirmationText: string },
  ) {}

  onConfirm() {
    this.matDialogRef.close({ confirmed: true });
  }

  onDecline() {
    this.matDialogRef.close({ confirmed: false });
  }
}
